import { render, staticRenderFns } from "./AgreementSchool.vue?vue&type=template&id=05cf3db8"
import script from "../../services/school/agreement-school.js?vue&type=script&lang=js&external"
export * from "../../services/school/agreement-school.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/signup-teacher.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports